import { Text } from '@hhgtech/hhg-components/mantine'
import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { Avatar, Box, BoxProps } from '@mantine/core'
import useStyles from './index.styles'
import { useIsMobile } from 'hooks/useIsMobile'

type Props = {
  url?: string
} & BoxProps

export const AppDownloadInfoCard = ({
  url,
  styles,
  classNames,
  className,
  ...rest
}: Props) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'AppDownloadInfoCard',
    styles,
    classNames,
  })
  const isMobile = useIsMobile()
  return (
    <Box className={cx(className, classes.root)} {...rest}>
      <img
        src={CommonGAssets.getAssetPath('appIntro/qr-code.jpg')}
        className={classes.thumb}
        alt="Qr Code"
        loading="lazy"
      />
      <div className={classes.info}>
        <div className={classes.download}>
          <Avatar.Group>
            {new Array(4).fill('').map((_i, idx) => (
              <Avatar
                key={idx}
                src={CommonGAssets.getAssetPath(
                  `appIntro/avatar${idx + 1}.jpg`,
                )}
                size={28}
                radius="xl"
              />
            ))}
          </Avatar.Group>
          <Text size="p4">30k+ người dùng sử dụng sản phẩm của chúng tôi</Text>
        </div>
        <div className={classes.apps}>
          <Box
            {...(isMobile &&
              url && {
                component: 'a' as any,
                href: url,
                target: '_blank',
                'data-event-category': 'App Install',
                'data-event-action': 'Open App Store',
                'data-event-label': url,
              })}
          >
            <img
              src={CommonGAssets.getAssetPath('appIntro/app-store.png')}
              className={classes.app}
              alt="App Store"
              loading="lazy"
            />
          </Box>
          <Box
            {...(isMobile &&
              url && {
                component: 'a' as any,
                href: url,
                target: '_blank',
                'data-event-category': 'App Install',
                'data-event-action': 'Open Google Play',
                'data-event-label': url,
              })}
          >
            <img
              src={CommonGAssets.getAssetPath('appIntro/google-play.png')}
              className={classes.app}
              alt="Google Play"
              loading="lazy"
            />
          </Box>
        </div>
      </div>
    </Box>
  )
}
